import { render } from "./MyTitle.vue?vue&type=template&id=5438e5f8&scoped=true"
import script from "./MyTitle.vue?vue&type=script&lang=js"
export * from "./MyTitle.vue?vue&type=script&lang=js"

import "./MyTitle.vue?vue&type=style&index=0&id=5438e5f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5438e5f8"]])

export default __exports__